import { render } from "./BDropdown.vue?vue&type=template&id=58753681"
import script from "./BDropdown.vue?vue&type=script&lang=js"
export * from "./BDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__